import { VmaRdEnvironment } from 'global-types';

export const environment: VmaRdEnvironment = {
  production: true,
  env: 'production',
  nydusNetworkApiBaseUrl: 'https://vma-nn.kaligo.com',
  translationBaseUrl: './assets/i18n',
  guardhouseApiUrl: 'https://loyalty-auth.virginmoney.com.au',
  clientId: 'af66f478-a754-4593-9e1d-b43204636535',
  connection: 'vma',
  scope: 'openid,address,email,phone,profile,custom',
  redirectUri: 'https://rewards.virginmoney.com.au',
  travelEdgeBaseUrl: 'https://bookings.virginmoney.com.au',
  brandName: 'Virgin Money Australia',
  shortBrandName: 'VMA',
  hermesMode: 'iframe',
  idleCheckConfig: {
    timeout: 600,
    promptTimeout: 120,
  },
  sessionCheckPollInterval: 60,
  cookiesConfig: {
    localeCookieName: 'ascenda.locale',
    localeCookieDomain: 'virginmoney.com.au',
  },
  prismicConfig: {
    apiUrl: 'https://ascendaloyalty.prismic.io/api/v2',
    accessToken:
      'MC5ZSFpteHhNQUFDSUFxMERB.fu-_vX3vv73vv73vv70UFu-_vXJQ77-977-977-977-9I--_vU84R--_vR_vv70z77-977-9Ue-_vUNU77-977-9',
  },
  appId: 'cd089661-24b7-43ac-833f-2a87fc97dd9e',
  unleashAppName: 'rd-vma-prod',
  unleashClientKey:
    '*:production.ed9dc866a8362d926412ad673806fed91176182036fdca279f983b42',
};
